import { render } from "./VoorstelPopup.vue?vue&type=template&id=6c2ed4ac&scoped=true"
import script from "./VoorstelPopup.vue?vue&type=script&lang=js"
export * from "./VoorstelPopup.vue?vue&type=script&lang=js"

import "./VoorstelPopup.vue?vue&type=style&index=0&id=6c2ed4ac&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2ed4ac"]])

export default __exports__